'use client'
import * as React from 'react'
import { useTranslations } from 'next-intl'
import { Link } from '@repo/web-ui/components/link'
import { AppRoutes } from '@repo/web-utils/app-routes'
import type { SearchProduct } from 'cf-menu/components/search/search.types'
import { useConfigure, useInfiniteHits } from 'react-instantsearch'

import { DigitalAssetsIcon } from '../../../assets/icons'
import { useClubhousesGetDetailsQuery } from '@web/gen/clubhouses'
import { IconArrowForward } from '@repo/design-system-cf/components/icons'

export function AssetsBox({ slug }: { slug: string }) {
  const t = useTranslations('pages.clubhouse')
  const { results } = useInfiniteHits<SearchProduct>({})

  const { data: clubhouse } = useClubhousesGetDetailsQuery(
    {
      input: { clubhouseSlug: slug },
    },
    {
      select: data => data?.clubhousesGetDetails?.clubhouse,
    },
  )

  const digitalAssetsFilters = clubhouse?.digitalAssetsFilters?.map(item =>
    item.replace('type:', ''),
  )

  useConfigure({
    filters: digitalAssetsFilters
      ? digitalAssetsFilters.map(item => `type:'${item}'`).join(' OR ')
      : '',
  })

  return (
    <Link
      href={`${AppRoutes.CLUBHOUSE}${slug}/inspiration/assets/`}
      className={
        'rounded-[12px] col-span-1 flex flex-row items-center justify-start gap-3 border border-[#1313151F] bg-cf-yellow-50 shadow-[0px_2px_4px_0px_#0000001A] p-4 hover:shadow-none'
      }
    >
      <DigitalAssetsIcon className="size-6 sm:size-14 shrink-0 text-cf-yellow-600" />
      <div className="flex justify-between items-center w-full">
        <div className="flex sm:flex-col gap-2 sm:gap-0 items-center sm:items-start">
          <p className="text-cf-grey-1000 text-[18px] font-bold leading-[26px] md:text-[29px] md:leading-[38px]">
            {results?.nbHits.toLocaleString()}
          </p>
          <p className="text-14 font-medium text-cf-grey-800">{t('detailsbox.assets')}</p>
        </div>
        <IconArrowForward className="size-[18px] text-cf-purple-900 sm:hidden" />
      </div>
    </Link>
  )
}
